/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TAdvertiserId } from '../models/TAdvertiserId';
import type { TCreateAdvertiserRequest } from '../models/TCreateAdvertiserRequest';
import type { TCreateAdvertiserResponse } from '../models/TCreateAdvertiserResponse';
import type { TGetAdvertiserResponse } from '../models/TGetAdvertiserResponse';
import type { TListAdvertisersResponse } from '../models/TListAdvertisersResponse';
import type { TUpdateAdvertiserRequest } from '../models/TUpdateAdvertiserRequest';
import type { TUpdateAdvertiserResponse } from '../models/TUpdateAdvertiserResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdvertiserService {
    /**
     * Get Advertiser
     * @param id
     * @param relations
     * @returns TGetAdvertiserResponse TGetAdvertiserResponse
     * @throws ApiError
     */
    public static getAdvertiser(
        id: TAdvertiserId,
        relations?: string,
    ): CancelablePromise<TGetAdvertiserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/advertisers/{id}',
            path: {
                'id': id,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Update Advertiser
     * @param id
     * @param requestBody
     * @returns TUpdateAdvertiserResponse TUpdateAdvertiserResponse
     * @throws ApiError
     */
    public static updateAdvertiser(
        id: TAdvertiserId,
        requestBody: TUpdateAdvertiserRequest,
    ): CancelablePromise<TUpdateAdvertiserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/advertisers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Advertiser
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteAdvertiser(
        id: TAdvertiserId,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/advertisers/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * List Advertisers
     * @param name
     * @param isSagSignatory
     * @param isJpcAuthorizer
     * @param groupId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListAdvertisersResponse TListAdvertisersResponse
     * @throws ApiError
     */
    public static listAdvertisers(
        name?: string,
        isSagSignatory?: boolean,
        isJpcAuthorizer?: boolean,
        groupId?: string,
        limit?: number,
        page?: number,
        orderAsJsonString?: string,
        relations?: string,
    ): CancelablePromise<TListAdvertisersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/advertisers',
            query: {
                'name': name,
                'isSagSignatory': isSagSignatory,
                'isJpcAuthorizer': isJpcAuthorizer,
                'groupId': groupId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
            },
        });
    }
    /**
     * Create Advertiser
     * @param requestBody
     * @returns TCreateAdvertiserResponse TCreateAdvertiserResponse
     * @throws ApiError
     */
    public static createAdvertiser(
        requestBody: TCreateAdvertiserRequest,
    ): CancelablePromise<TCreateAdvertiserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/advertisers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
